import * as THREE from 'three';
import { FikoSahne } from '../FikoSahne';
import { FikoTakim } from "./FikoTakim";
import { FikoTakimTutucu } from './FikoTakimTutucu';


/**
 * FikoTakimFrezeleme - Frezeleme Takımı Sınıfı
 *
 * Desteklenen takım tipleri:
 * - ParmakFreze, VKesici, Elmas, KarbonUc, BallNose
 * - Punta, Matkap, Rayba, Kilavuz, Havsa
 */
export class FikoTakimFrezeleme extends FikoTakim {
    override type: "FikoTakimFrezeleme";
    shape: THREE.Shape;
    geometry: THREE.ExtrudeGeometry;
    material: THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial({ color: 0x91918A, polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 1/*, depthTest:false,depthWrite:false */ })
    govde: THREE.Mesh;
    edges: THREE.EdgesGeometry;
    lineSegments: THREE.LineSegments;
    govdeMaterial: THREE.LineBasicMaterial = new THREE.LineBasicMaterial({ color: 0x636363 });
    ucMaterial: THREE.LineBasicMaterial = new THREE.LineBasicMaterial({ color: 0xCCCC00 });

    // Takım tipi: Freze, V-Kesici, Elmas, Ball Nose, Karbon Uç, Delik takımları vb.
    takimTipi: 'ParmakFreze' | 'VKesici' | 'Elmas' | 'KarbonUc' | 'BallNose' | 'Punta' | 'Matkap' | 'Rayba' | 'Kilavuz' | 'Havsa' | string = 'ParmakFreze';

    // Takım adı
    ad: string = 'T1';

    constructor(public override sahne?: FikoSahne, public cap: number = 10, public radius: number = 0, public boy: number = 100, public kesmeBoy: number = 10) {
        super(sahne);
        this.tutucu=new FikoTakimTutucu(sahne)
        this.ekle(this.tutucu)
        this.hazirla();
    }

    override hazirla() {
        this.shape = new THREE.Shape();
        this.shape.ellipse(0, 0, this.cap / 2, this.cap / 2, 0, Math.PI * 180, true, 0);

        this.geometry = new THREE.ExtrudeGeometry(this.shape, { curveSegments: 128, steps: 5, depth: this.boy - this.kesmeBoy, bevelEnabled: false });

        this.govde = new THREE.Mesh(this.geometry, this.material);
        
        this.edges = new THREE.EdgesGeometry(this.geometry);
        this.lineSegments = new THREE.LineSegments(this.edges, this.govdeMaterial);

        this.govde.add(this.lineSegments);
        this.govde.translateZ(this.kesmeBoy+this.radius)
        
        /** Kesme Boyu */
        let kesmeGeo = new THREE.ExtrudeGeometry(this.shape, { curveSegments: 128, steps: 5, depth: this.kesmeBoy, bevelEnabled: false });
        let kesmeMesh = new THREE.Mesh(kesmeGeo, new THREE.MeshBasicMaterial({ color: 0xC8C833, polygonOffset:true, polygonOffsetFactor:1,polygonOffsetUnits:1/*, depthTest:false,depthWrite:false*/ }));
        let kesmeEdges = new THREE.EdgesGeometry(kesmeGeo);
        let kesmeLines = new THREE.LineSegments(kesmeEdges, this.ucMaterial);
        kesmeMesh.add(kesmeLines);

        this.add(kesmeMesh);

        /** Rediüs Yarı Çapı Kadar Havaya Kaldırılıyor */
        kesmeMesh.translateZ(this.radius);
        /** Radiüs Çiziliyor */
        if (this.radius == this.cap / 2) {
            let kureGeo = new THREE.SphereGeometry(this.radius, 128, 128);
            let kureMesh = new THREE.Mesh(kureGeo, new THREE.MeshBasicMaterial({ color: 0xBABA00, polygonOffset:true, polygonOffsetFactor:1,polygonOffsetUnits:1/*, depthTest:false,depthWrite:false*/ }));

            let kureEdges = new THREE.LineSegments(new THREE.EdgesGeometry(kureGeo), this.ucMaterial);
            kureMesh.add(kureEdges);
            kureMesh.translateZ((this.radius));
            this.add(kureMesh);
        } else if (this.radius > 0) {

            let torusGeo = new THREE.TorusGeometry((this.cap / 2) - (this.radius), this.radius, 128, 128);
            let torusMesh = new THREE.Mesh(torusGeo, new THREE.MeshBasicMaterial({ color: 0xBABA00, polygonOffset:true, polygonOffsetFactor:1,polygonOffsetUnits:1/*, depthTest:false,depthWrite:false*/ }));

            let torusEdges = new THREE.LineSegments(new THREE.EdgesGeometry(torusGeo), this.ucMaterial);
            torusMesh.add(torusEdges);

            torusMesh.translateZ((this.radius));

            this.tutucu.add(torusMesh);
        }

        this.add(this.govde);
    }

    guncelle() {
        this.remove(this.govde);

        this.shape = new THREE.Shape();
        this.shape.ellipse(0, 0, this.cap / 2, this.cap / 2, 0, Math.PI * 180, true, 0);

        this.geometry = new THREE.ExtrudeGeometry(this.shape, { steps: 2, depth: this.boy, bevelEnabled: false });



        this.govde = new THREE.Mesh(this.geometry, this.material);

        // this.edges = new THREE.EdgesGeometry(this.geometry);
        // this.lineSegments = new THREE.LineSegments(this.edges, this.blackLineMaterial);
        // this.mesh.add(this.lineSegments);

        this.tutucu.add(this.govde);
    }
}